var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#FF3118",
  viewBox: "0 0 14 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.154 6.787C13.154 11.769 6.577 18 6.577 18S0 11.77 0 6.787C0 3.039 2.945 0 6.577 0s6.577 3.039 6.577 6.787"
})));
export default SvgIconPin;